module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/bad/group_items-8a339d15bce895f478507558e30d699a.png";